import { fetcher } from '@commenda/utils';
import { TTPAuditPacketFilesResponse } from './types';

export async function getAuditPacketFiles(
  packetId: string
): Promise<TTPAuditPacketFilesResponse> {
  const response = await fetcher(`tp-audit-packet/${packetId}/files`, {
    method: 'GET',
  });
  if (!response.ok) throw new Error('Failed to fetch audit packet files');
  return (await response.json()) as TTPAuditPacketFilesResponse;
}
